<!-- Container -->
<div class="container">

  <ul>
    <li>
      At the login screen, choose the option at the bottom to "Sign Up"
    </li>

    <li class="img-to-text">
      Complete all fields on the next screen and tap the red "Sign Up" button

      <div class="row">
          <!-- create_account_1.png -->
          <img [src]="getImgs[0]"
          class="help-img"
          (click)="showImage(getImgs[0])" />
          
           <!-- create_account_2.png -->
          <img [src]="getImgs[1]"
          class="help-img"
          (click)="showImage(getImgs[1])" />
      </div>


      
    </li>

    <li>
      Next add your vessel(s).
      Choose the red + button and add vessel name and number
    </li>

    <li class="img-to-text">
      If the vessel is not recognized, a warning will ask you to check for errors.
      Not all vessels will be recognized, so choose "Continue" if all vessel information is correct.

      <div class="row">
        <!-- vessel_reg_1.png -->
        <img [src]="getImgs[2]"
          class="help-img"
          (click)="showImage(getImgs[2])" />

        <!-- vessel_reg_2.png -->
        <img [src]="getImgs[3]"
              class="help-img"
              (click)="showImage(getImgs[3])" />
      </div>
      
    <li>
      An email will be sent to confirm the address you used at sign-up.
      Be sure to read and follow the directions in the email or you will not be able to submit your logbook.
    </li>
  </ul>
</div>
